/**
 * Auditoria
 * @author Simpli CLI generator
 */
import {$, Helper, Request, Resource} from 'simpli-web-sdk'
import {ResponseSerialize} from 'simpli-web-sdk'
import {AuditoriaMotivo} from '@/model/resource/AuditoriaMotivo'
import {Carga} from '@/model/resource/Carga'
import {Responsavel} from '@/model/resource/Responsavel'
import {AuditoriaCollection} from '@/model/collection/AuditoriaCollection'

/* TODO: review generated class */
export class Auditoria extends Resource {
  idAuditoriaPk: number = 0

  @ResponseSerialize(AuditoriaMotivo)
  auditoriaMotivo: AuditoriaMotivo | null = null

  @ResponseSerialize(Carga)
  carga: Carga | null = null

  @ResponseSerialize(Responsavel)
  responsavel: Responsavel | null = null

  conforme: boolean | null = null
  dataCriacao: string | null = null

  dataCanhoto: string | null = null
  idMotivoFk: number | null = null

  get $id() {
    return this.idAuditoriaPk
  }
  set $id(val) {
    this.idAuditoriaPk = val
  }

  get idResponsavelFk() {
    if (!this.responsavel) return 0
    return this.responsavel.$id
  }
  set idResponsavelFk(val) {
    if (!this.responsavel) this.responsavel = new Responsavel()
    this.responsavel.$id = val
  }

  get idCargaFk() {
    if (!this.carga) return 0
    return this.carga.$id
  }
  set idCargaFk(val) {
    if (!this.carga) this.carga = new Carga()
    this.carga.$id = val
  }

  /**
   * Gets a instance of a given ID of Auditoria
   */
  async getAuditoria(id: number) {
    return await Request.get(`/admin/auditoria/${id}`)
      .name('getAuditoria')
      .as(this)
      .getData()
  }

  /**
   * Lists the instances of Auditoria
   */
  static async listAuditoria(params: any) {
    return await Request.get(`/admin/auditoria`, {params})
      .name('listAuditoria')
      .as(AuditoriaCollection)
      .getData()
  }

  /**
   * Persists a new instance of Auditoria. Use ID = 0 to create a new one,
   * or ID > 0 to update a current one
   */
  async persistAuditoria() {
    return await Request.post(`/admin/auditoria`, this)
      .name('persistAuditoria')
      .asNumber()
      .getData()
  }

  /**
   * Lists the instances of Auditoria to use it in a CSV file
   */
  static async listCsvAuditoria(params: any) {
    return await Request.get(`/admin/auditoria/csv`, {params})
      .name('listCsvAuditoria')
      .as(AuditoriaCollection)
      .getData()
  }
}
